/* eslint @typescript-eslint/no-explicit-any: 0 */
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ExceptionTrackingService,
  IExceptionMetadata
} from '@com-delta-idp/mnx-utils';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { EXCEPTION_CATEGORY_ENUM } from '../../constants/exception-tracking.constants';

const fileName = 'fr-error-logger.service.ts';

@Injectable({
  providedIn: 'root'
})
export class ErrorLoggerService implements HttpInterceptor {
  constructor(private exceptionTrackingService: ExceptionTrackingService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      retry(1),
      catchError((error: HttpErrorResponse) => {
        if (error.error instanceof ErrorEvent) {
          this._handleClientError(error);
        } else {
          this._handleServerError(error);
        }
        return throwError(error);
      })
    );
  }

  /**
   * Method to handle HTTP response
   * @param event
   */
  private _handleClientError(event: HttpErrorResponse) {
    const exceptionMetadata: IExceptionMetadata = {
      fileName,
      methodName: '_handleClientError',
      exceptionCategory: EXCEPTION_CATEGORY_ENUM.API_EMPTY_RESPONSE,
      exceptionMessage: 'API empty response'
    };
    this.exceptionTrackingService.track(
      `${event.status} : ${event.url}`,
      exceptionMetadata
    );
  }

  /**
   * Method to handle HTTP Error Response
   * @param event
   */
  private _handleServerError(event: HttpErrorResponse) {
    const exceptionMetadata: IExceptionMetadata = {
      fileName,
      methodName: '_handleServerError',
      exceptionCategory: EXCEPTION_CATEGORY_ENUM.API_FAILURE,
      exceptionMessage: JSON.stringify(event.error)
    };
    this.exceptionTrackingService.track(
      `${event.status} : ${event.url}`,
      exceptionMetadata
    );
  }
}
